import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function WebIcon({ link, style, className }) {
  if (logComponent('WebIcon')) { console.debug('WebIcon rendered'); }

  return  (
    <a href={link} className={className} title="Website" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon="globe" />
    </a>
  )
}